import { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";

const LAYER_NAME_MAX_LENGTH = 80;

const LayerNameEditor = ({ name, onStartEdit, onCommit }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(name);
  const cancelingRef = useRef(false);

  useEffect(() => {
    if (!isEditing) {
      setDraft(name);
    }
  }, [isEditing, name]);

  const commit = () => {
    setIsEditing(false);
    onCommit(draft);
  };

  if (!isEditing) {
    return (
      <Typography
        variant="body2"
        onClick={(event) => {
          event.stopPropagation();
          onStartEdit();
          setDraft(name);
          setIsEditing(true);
        }}
        sx={{
          fontWeight: 700,
          color: "text.primary",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          lineHeight: 1.3,
          cursor: "text",
        }}
      >
        {name}
      </Typography>
    );
  }

  return (
    <Box
      component="input"
      value={draft}
      autoFocus
      maxLength={LAYER_NAME_MAX_LENGTH}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      onFocus={(event) => event.target.select()}
      onChange={(event) => setDraft(event.target.value)}
      onBlur={() => {
        if (cancelingRef.current) {
          cancelingRef.current = false;
          return;
        }
        commit();
      }}
      onKeyDown={(event) => {
        event.stopPropagation();
        if (event.key === "Enter") {
          event.preventDefault();
          event.currentTarget.blur();
          return;
        }
        if (event.key === "Escape") {
          event.preventDefault();
          cancelingRef.current = true;
          setDraft(name);
          setIsEditing(false);
        }
      }}
      sx={{
        width: "100%",
        minWidth: 0,
        border: "none",
        outline: "none",
        bgcolor: "transparent",
        p: 0,
        m: 0,
        fontSize: 14,
        fontWeight: 700,
        lineHeight: 1.3,
        color: "text.primary",
        fontFamily: "inherit",
      }}
    />
  );
};

export default LayerNameEditor;
